import { action } from 'typesafe-actions';

import * as Constants from './constants';
import * as Types from './types';

export const List = {
  request: (args: Types.IAction.List.Request) => action(Constants.LIST.REQUEST, args),
  success: (args: Types.IAction.List.Success) => action(Constants.LIST.SUCCESS, args),
  failure: (args: Types.IAction.List.Failure) => action(Constants.LIST.FAILURE, args)
};

export const User = {
  request: (args?: Types.IAction.User.Request) => action(Constants.USER.REQUEST, args),
  success: (args: Types.IAction.User.Success) => action(Constants.USER.SUCCESS, args),
  failure: (args: Types.IAction.User.Failure) => action(Constants.USER.FAILURE, args)
};